import { Team__Nogaleras } from "../teams/Nogaleras";
import { Team__Potras } from "../teams/Potras";
import { Team__Pythons } from "../teams/Pythons";
import { Team__Raptors } from "../teams/Raptors";
import { Team__UTPaquime } from "../teams/UTPaquime";

const Nogaleras = {
  team: Team__Nogaleras,
  playingPlayers: [],

  goals: 38,
  penaltyGoals: 0,
  isWinner: false,
};

const Raptors = {
  team: Team__Raptors,
  playingPlayers: [],

  goals: 22,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 36,
  penaltyGoals: 0,
  isWinner: false,
};

const Potras = {
  team: Team__Potras,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Pythons = {
  team: Team__Pythons,
  playingPlayers: [],

  goals: 32,
  penaltyGoals: 0,
  isWinner: false,
};

// =========================
// =========================
// =========================

const Seed1 = {
  team: {
    name: "1st seed",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Seed2 = {
  team: {
    name: "2nd seed",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Seed3 = {
  team: {
    name: "3rd seed",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Seed4 = {
  team: {
    name: "4 seed",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada5 = {
  jornadaPosition: 5,
  matches: [
    {
      team1: Nogaleras,
      team2: Raptors,

      isCompleted: true,
      isPlaying: true,
      day: "Viernes",
      date: "2025-08-01",
      time: "11:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: UTPaquime,
      team2: Pythons,

      isCompleted: true,
      isPlaying: false,
      day: "Viernes",
      date: "2025-08-01",
      time: "12:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
